import {makeReducer} from '../../redux-toolbelt';

import {setHasInitialScrollHappenedAction} from './hasInitialScrollHappenedActions';

type HasInitialScrollHappenedState = boolean;

export default makeReducer<HasInitialScrollHappenedState, HasInitialScrollHappenedState>(setHasInitialScrollHappenedAction, {defaultState: false});
